/**
 *  Created by long.wang on 2019/4/11
 */
export default {
  sensors: {
    server_url: 'https://sensorsdata.ppdai.com/sa/?project=production',
    show_log: false
  },
  LYCF_LOGIN_URL: '//ac.lyfortune.com/h5/authLogin?thirdAppId=f232b5b808cd4128aafc998661abe900&thirdCallUrl=http://passport.ppdapi.com/v2/authorizedLoginService/queryPhoneByOpenId?appid=1000003195&',
}
